import { render, staticRenderFns } from "./AccountBiography.vue?vue&type=template&id=00348b1c&scoped=true"
import script from "./AccountBiography.vue?vue&type=script&lang=js"
export * from "./AccountBiography.vue?vue&type=script&lang=js"
import style0 from "./AccountBiography.vue?vue&type=style&index=0&id=00348b1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00348b1c",
  null
  
)

export default component.exports